// src/index.ts
function isTopBrowser() {
  var _a, _b;
  try {
    return (
      // @ts-ignore
      Boolean(navigator.userAgent.match(/chrome\/[\d.]+/gi)) && Boolean(navigator == null ? void 0 : navigator.userAgentData) || Boolean((_a = navigator.storage) == null ? void 0 : _a.getDirectory) || Boolean(navigator.canShare) || (((_b = window.Promise) == null ? void 0 : _b.allSettled) || "").toString().indexOf("[native code]") !== -1 && Boolean(
        Number((navigator.userAgent.match(/Chrome\/(\d+\.+\d+)/) || [])[1]) >= 76 && window.visualViewport
      )
    );
  } catch (e) {
    return false;
  }
}
export {
  isTopBrowser
};
